import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "pb-10 mb-10 lg:py-6 enter-content-animation md:px-0 sm:pt-10 category-show sf-scope font-inter left-0 right-0 top-0 bottom-0 h-full",
  style: {"min-height":"40rem"}
}
const _hoisted_2 = {
  class: "px-4 items-center py-0 pb-4 category-show__nav hidden pt-4 border-b sticky top-0 bg-white w-full",
  style: {"z-index":"50","border-color":"rgb(204 204 204 / 22%)"}
}
const _hoisted_3 = {
  viewBox: "0 0 24 24",
  role: "presentation",
  style: {"width":"1.5rem","height":"1.5rem"}
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z",
  style: {"fill":"currentcolor"}
}, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "font-semibold left-1/2 -translate-x-1/2 absolute only-1-lines min-w-64 text-center font-bold text-lg font-poppins" }
const _hoisted_7 = { class: "rounded-full bg-gray-200 box-shadow w-10 h-10 flex justify-center items-center" }
const _hoisted_8 = {
  viewBox: "0 0 24 24",
  role: "presentation",
  style: {"width":"1.5rem","height":"1.5rem"}
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("path", {
  d: "M20,11V13H8L13.5,18.5L12.08,19.92L4.16,12L12.08,4.08L13.5,5.5L8,11H20Z",
  style: {"fill":"currentcolor"}
}, null, -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "px-4 flex gap-4 mb-6 mt-4" }
const _hoisted_12 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 24 24",
  fill: "none"
}
const _hoisted_13 = { class: "px-4" }
const _hoisted_14 = {
  key: 0,
  class: "flex flex-col items-center justify-center row-gap-4"
}
const _hoisted_15 = /*#__PURE__*/_createStaticVNode("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"90\" height=\"90\" viewBox=\"0 0 53 51\" fill=\"none\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6.7489 24.5609L4.87989 36.7463C4.53529 38.9788 5.88108 41.1042 7.96494 41.6754L34.1846 48.863C36.2685 49.4343 38.51 48.2923 39.352 46.1961L44.0202 34.7781L45.057 35.0623C45.6273 35.2186 46.2223 34.8782 46.3791 34.3059L47.2349 31.1841C47.3918 30.6118 47.0536 30.0156 46.4834 29.8592L30.0614 25.3575C29.7968 25.5089 28.9643 25.9852 28.9671 25.975C28.1709 26.4391 27.2239 26.56 26.3426 26.3184C25.4613 26.0768 24.6979 25.4871 24.2602 24.6847C24.0799 24.3669 23.9419 24.0156 23.8719 23.6608L7.08698 19.0595C6.51675 18.9032 5.92176 19.2436 5.76487 19.8159L4.90911 22.9377C4.75222 23.51 5.09046 24.1062 5.66066 24.2626L6.7489 24.5609ZM19.3266 31.3764L18.3095 39.153C18.2422 39.6829 18.6607 40.1891 19.248 40.283C19.8353 40.377 20.368 40.0195 20.438 39.4794L21.4551 31.7027C21.5223 31.1728 21.1039 30.6667 20.5165 30.5727C19.9292 30.4787 19.3966 30.8362 19.3294 31.3661L19.3266 31.3764ZM12.0692 29.3869L11.0521 37.1635C10.9848 37.6934 11.4033 38.1996 11.9907 38.2936C12.578 38.3875 13.1106 38.03 13.1806 37.4899L14.1977 29.7133C14.265 29.1834 13.8465 28.6772 13.2592 28.5832C12.6718 28.4893 12.1392 28.8468 12.072 29.3766L12.0692 29.3869ZM27.683 33.421L24.5922 40.6292C24.3799 41.1193 24.6558 41.6982 25.206 41.9273C25.7592 42.1459 26.3773 41.924 26.5896 41.4338L29.6804 34.2256C29.8927 33.7355 29.6168 33.1566 29.0637 32.9377C28.5106 32.7191 27.8925 32.9411 27.6802 33.4312L27.683 33.421ZM34.9403 35.4104L31.8496 42.6186C31.6373 43.1087 31.9132 43.6877 32.4634 43.9168C33.0166 44.1354 33.6347 43.9134 33.847 43.4233L36.9377 36.2151C37.1501 35.725 36.8742 35.1461 36.3211 34.9272C35.768 34.7086 35.1499 34.9306 34.9375 35.4207L34.9403 35.4104ZM26.9125 24.2372C26.5809 24.1463 26.3068 23.9259 26.1311 23.6316L26.1206 23.6287C25.9657 23.3401 25.9135 23.0014 25.9785 22.6835C26.0783 22.3194 26.2941 22.0203 26.6113 21.8389L40.6386 13.8139C41.2599 13.4585 42.0581 13.6773 42.4113 14.2999C42.5842 14.6047 42.6276 14.9745 42.5364 15.3074C42.4451 15.6403 42.2322 15.9289 41.9312 16.0925L27.8947 24.115C27.601 24.2918 27.2427 24.3389 26.9107 24.2479L26.9125 24.2372ZM17.8807 11.603C14.589 12.1439 11.6868 14.436 10.3007 17.7035L24.1415 21.4977C24.4485 20.866 24.9438 20.3191 25.5549 19.9608L28.265 18.4103C27.8141 16.8433 26.9862 15.4305 25.876 14.2759C25.0508 13.4231 24.0752 12.7529 23.0116 12.2826C23.5086 10.2262 23.2629 8.68202 22.7081 7.53412C21.2952 4.59588 17.7147 4.11791 17.7147 4.11791C17.1971 4.0543 16.7231 4.3606 16.5551 4.85162C16.5551 4.85162 15.2807 8.80961 17.8735 11.59L17.8807 11.603ZM43.2708 17.7912C43.1887 17.847 32.7156 23.8475 32.7156 23.8475L43.9541 26.9283L44.5246 24.8473L39.3409 23.4262C38.7707 23.2699 38.4325 22.6737 38.5894 22.1014C38.7462 21.5291 39.3413 21.1886 39.9115 21.3449L45.0952 22.7659L45.3919 21.6836C45.6144 20.8719 45.5096 19.993 45.0862 19.2615C44.688 18.5596 44.0403 18.0351 43.2682 17.8012L43.2708 17.7912ZM27.6683 9.03925L26.9634 8.84601L26.9114 8.83177C26.1328 8.6631 25.4019 9.13383 25.2107 9.83112L24.994 10.6219C26.1226 11.0991 27.1471 11.794 28.0185 12.6817C28.7496 13.4304 29.3474 14.2989 29.8104 15.2538L35.5873 11.9485C35.46 11.4774 35.1018 11.077 34.573 10.9321L33.8783 10.7416L34.7341 7.6199C34.891 7.04757 34.5426 6.44854 33.9619 6.28937L29.8461 5.1611C29.2654 5.00193 28.6603 5.33957 28.5034 5.91188L27.6476 9.03362L27.6683 9.03925Z\" fill=\"#292F31\"></path><circle cx=\"17.9206\" cy=\"13.2976\" r=\"1\" transform=\"rotate(15.3299 17.9206 13.2976)\" fill=\"white\"></circle><circle cx=\"15.463\" cy=\"14.698\" r=\"1\" transform=\"rotate(15.3299 15.463 14.698)\" fill=\"white\"></circle><circle cx=\"16.8631\" cy=\"17.1556\" r=\"1\" transform=\"rotate(15.3299 16.8631 17.1556)\" fill=\"white\"></circle><circle cx=\"20.0208\" cy=\"16.9842\" r=\"1\" transform=\"rotate(15.3299 20.0208 16.9842)\" fill=\"white\"></circle><circle cx=\"20.8139\" cy=\"14.0911\" r=\"1\" transform=\"rotate(15.3299 20.8139 14.0911)\" fill=\"white\"></circle></svg><p class=\"font-semibold text-lg\"> Nenhum produto foi encontrado </p><p class=\"text-gray-500 text-sm\">Volte mais tarde</p>", 3)
const _hoisted_18 = [
  _hoisted_15
]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "absolute top-3 bg-gray-300 w-10 h-1 left-1/2 -translate-x-1/2" }, null, -1)
const _hoisted_20 = { class: "flex items-center justify-between pb-2" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("h4", { class: "font-bold text-neutral-800 text-lg" }, "Ordenar por", -1)
const _hoisted_22 = {
  viewBox: "0 0 24 24",
  role: "presentation",
  style: {"width":"1.5rem","height":"1.5rem"}
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("path", {
  d: "M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z",
  style: {"fill":"currentcolor"}
}, null, -1)
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-gray-500 pb-4" }, "Ordene os produtos de acordo como desejar", -1)
const _hoisted_26 = { class: "grid grid-cols-12 gap-4" }
const _hoisted_27 = { class: "col-span-4 items-center flex flex-col gap-2" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M13.4101 20.79L12.0001 21.7C10.6901 22.51 8.87006 21.6 8.87006 19.98V14.63C8.87006 13.92 8.47006 13.01 8.06006 12.51L4.22006 8.46997C3.71006 7.95997 3.31006 7.06001 3.31006 6.45001V4.13C3.31006 2.92 4.22006 2.01001 5.33006 2.01001H18.6701C19.7801 2.01001 20.6901 2.92003 20.6901 4.03003V6.25C20.6901 7.06 20.1801 8.07001 19.6801 8.57001",
    stroke: "#292f31",
    "stroke-width": "1.5",
    "stroke-miterlimit": "10",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M21.6299 14.75C21.6299 15.64 21.3799 16.48 20.9399 17.2C20.1199 18.58 18.6099 19.5 16.8799 19.5C15.1499 19.5 13.6399 18.57 12.8199 17.2C12.3799 16.49 12.1299 15.64 12.1299 14.75C12.1299 12.13 14.2599 10 16.8799 10C19.4999 10 21.6299 12.13 21.6299 14.75Z",
    stroke: "#292f31",
    "stroke-width": "1.5",
    "stroke-miterlimit": "10",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M18.1501 15.99L15.6401 13.48",
    stroke: "#292f31",
    "stroke-width": "1.5",
    "stroke-miterlimit": "10",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M18.1301 13.51L15.6201 16.02",
    stroke: "#292f31",
    "stroke-width": "1.5",
    "stroke-miterlimit": "10",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M20.6901 4.02002V6.23999C20.6901 7.04999 20.1801 8.06001 19.6801 8.57001L17.9201 10.12C17.5901 10.04 17.2401 10 16.8801 10C14.2601 10 12.1301 12.13 12.1301 14.75C12.1301 15.64 12.3801 16.48 12.8201 17.2C13.1901 17.82 13.7001 18.35 14.3201 18.73V19.07C14.3201 19.68 13.9201 20.49 13.4101 20.79L12.0001 21.7C10.6901 22.51 8.87006 21.6 8.87006 19.98V14.63C8.87006 13.92 8.46006 13.01 8.06006 12.51L4.22006 8.46997C3.72006 7.95997 3.31006 7.05001 3.31006 6.45001V4.12C3.31006 2.91 4.22006 2 5.33006 2H18.6701C19.7801 2 20.6901 2.91002 20.6901 4.02002Z",
    stroke: "#292f31",
    "stroke-width": "1.5",
    "stroke-miterlimit": "10",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs sm:text-sm" }, "Limpar", -1)
const _hoisted_31 = { class: "col-span-4 items-center flex flex-col gap-2" }
const _hoisted_32 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}
const _hoisted_33 = { class: "col-span-4 items-center flex flex-col gap-2" }
const _hoisted_34 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "24",
  viewBox: "0 0 25 24",
  fill: "none"
}

import { onMounted, onBeforeUnmount, ref, computed } from 'vue';
import { hideNav, /*restaurant,*/ categories } from '@/global/state/GlobalState';
import StoreProductGrid from '@/components/storefront/StoreProductGrid.vue'
import { ProductModel } from '@/models/ProductModel'
import ProductModal from '@/components/modal/ProductModal.vue'
import MyModal from '@/components/modal/MyModal.vue';
// import axiosClient from '@/api/axios';
import { useCategory } from '@/composables/useCategory'

/* global defineProps */

export default /*#__PURE__*/_defineComponent({
  __name: 'CategoriesShow',
  props: {
    id: {}
  },
  setup(__props: any) {

const props = __props
const category = ref<any>({})
const isProductModalOpen = ref<boolean>(false)
const isOrderByModalOpen = ref<boolean>(false)
const filter = ref<string[]>([])
const orderProductBy = ref<string>('')
const selectedProduct = ref<any>({})
const translations: {[key: string]: string} = {
  'price': 'Preço',
  'preparationTime':'Preparo',
  'discount':'Desconto'
}

const products = computed(() => {
  let filteredProducts = category.value?.products?.filter((product: ProductModel) => {
    if (filter.value.includes('only_promotional')) {
      return product.promotionalPrice && product.promotionalPrice < product.price;
    }
    return true;
  });

  if (orderProductBy.value === 'price') {
    filteredProducts.sort((a: ProductModel, b: ProductModel) => {
      const aPrice =  a.promotionalPrice ?? a.price
      const bPrice =  b.promotionalPrice ?? b.price
      return aPrice - bPrice
    });
  } else if(orderProductBy.value === 'discount'){
    filteredProducts.sort((a: ProductModel, b: ProductModel) => {
      const aDiscount = a.price - (a.promotionalPrice ?? a.price);
      const bDiscount = b.price - (b.promotionalPrice ?? b.price);
      return bDiscount - aDiscount; 
    });
  }

  return filteredProducts ?? [];
});

onMounted(() => {
  hideNav.value = true

  if(!categories.value){
      const { listCategories, categories: categoryList } = useCategory()
      
      listCategories({ perPage: 100 }).then(() => {
          categories.value = categoryList.value
          category.value = categories.value.find((category: any) => category.id == props.id)
      })
  } else{
    category.value = categories.value.find((category: any) => category.id == props.id)
  }
})

onBeforeUnmount(() => {
  hideNav.value = false
})

function togglePromotionalFilter() {
  if (filter.value.includes('only_promotional')) {
    filter.value = filter.value.filter((item) => item !== 'only_promotional');
  } else {
    filter.value.push('only_promotional');
  }
}

const setModalProduct = (product: ProductModel) => {
  selectedProduct.value = product
  isProductModalOpen.value = !isProductModalOpen.value
}

return (_ctx: any,_cache: any) => {
  return (category.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("button", {
            class: "transition duration-200 hover:text-primary rounded-full justify-self-start left-4",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1)))
          }, [
            (_openBlock(), _createElementBlock("svg", _hoisted_3, _hoisted_5))
          ]),
          _createElementVNode("h2", _hoisted_6, _toDisplayString(category.value.name), 1)
        ]),
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.go(-1))),
          class: "font-inter font-medium flex items-center gap-4 text-2xl font-bold transition-color duration-200 hover:text-primary pb-8 category-show__go-back"
        }, [
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(), _createElementBlock("svg", _hoisted_8, _hoisted_10))
          ]),
          _createTextVNode(" " + _toDisplayString(category.value.name), 1)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("button", {
            class: _normalizeClass(["p-2 px-4 bg-f5 text-sm font-semibold rounded-3xl flex items-center gap-1 hover:text-primary transition-color duration-200 hover:stroke-primary", orderProductBy.value ? 'text-primary':'']),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (isOrderByModalOpen.value = true))
          }, [
            _createTextVNode(_toDisplayString(orderProductBy.value ? translations[orderProductBy.value] : 'Ordenar') + " ", 1),
            (_openBlock(), _createElementBlock("svg", _hoisted_12, [
              _createElementVNode("path", {
                d: "M19.92 8.94995L13.4 15.47C12.63 16.24 11.37 16.24 10.6 15.47L4.08 8.94995",
                class: _normalizeClass(["hover-parent:stroke-primary transition-stroke duration-200", orderProductBy.value ? 'stroke-primary':'']),
                stroke: "#292f31",
                "stroke-width": "1.5",
                "stroke-miterlimit": "10",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, null, 2)
            ]))
          ], 2),
          _createElementVNode("button", {
            class: _normalizeClass(["p-2 px-4 bg-f5 text-sm font-semibold rounded-3xl", filter.value.includes('only_promotional') ? 'text-primary':'']),
            onClick: togglePromotionalFilter
          }, "Promocionais", 2)
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(StoreProductGrid, {
            products: products.value,
            thumb: false,
            onSelect: setModalProduct
          }, null, 8, ["products"])
        ]),
        (!products.value?.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_18))
          : _createCommentVNode("", true),
        _createVNode(MyModal, {
          width: '30rem',
          height: '24rem',
          className: 'font-inter p-4',
          id: 'order-by-modal',
          isOpen: isOrderByModalOpen.value,
          toggleModal: (v) => isOrderByModalOpen.value = v,
          zIndex: 60
        }, {
          default: _withCtx(() => [
            _hoisted_19,
            _createElementVNode("div", _hoisted_20, [
              _hoisted_21,
              _createElementVNode("button", {
                class: "transition duration-200 hover:text-primary",
                onClick: _cache[3] || (_cache[3] = ($event: any) => {isOrderByModalOpen.value = false;})
              }, [
                (_openBlock(), _createElementBlock("svg", _hoisted_22, _hoisted_24))
              ])
            ]),
            _hoisted_25,
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("button", {
                  class: "border rounded-full p-5",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => {orderProductBy.value = ''; isOrderByModalOpen.value = false})
                }, _hoisted_29),
                _hoisted_30
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("button", {
                  class: _normalizeClass(["border rounded-full p-5", orderProductBy.value == 'price' ? 'border-transparent outline outline-2 outline-primary':'outline-none']),
                  onClick: _cache[5] || (_cache[5] = ($event: any) => {orderProductBy.value = 'price'; isOrderByModalOpen.value = false})
                }, [
                  (_openBlock(), _createElementBlock("svg", _hoisted_32, [
                    _createElementVNode("path", {
                      d: "M17.0098 20.5H7.00977C4.00977 20.5 2.00977 19 2.00977 15.5V8.5C2.00977 5 4.00977 3.5 7.00977 3.5H17.0098C20.0098 3.5 22.0098 5 22.0098 8.5V15.5C22.0098 19 20.0098 20.5 17.0098 20.5Z",
                      stroke: "#292f31",
                      class: _normalizeClass(["", orderProductBy.value == 'price' ? 'stroke-primary':'']),
                      "stroke-width": "1.5",
                      "stroke-miterlimit": "10",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    }, null, 2),
                    _createElementVNode("path", {
                      d: "M12.0098 15C13.6666 15 15.0098 13.6569 15.0098 12C15.0098 10.3431 13.6666 9 12.0098 9C10.3529 9 9.00977 10.3431 9.00977 12C9.00977 13.6569 10.3529 15 12.0098 15Z",
                      stroke: "#292f31",
                      class: _normalizeClass(["", orderProductBy.value == 'price' ? 'stroke-primary':'']),
                      "stroke-width": "1.5",
                      "stroke-miterlimit": "10",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    }, null, 2),
                    _createElementVNode("path", {
                      d: "M5.50977 9.5V14.5",
                      stroke: "#292f31",
                      class: _normalizeClass(["", orderProductBy.value == 'price' ? 'stroke-primary':'']),
                      "stroke-width": "1.5",
                      "stroke-miterlimit": "10",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    }, null, 2),
                    _createElementVNode("path", {
                      d: "M18.5098 9.5V14.5",
                      stroke: "#292f31",
                      class: _normalizeClass(["", orderProductBy.value == 'price' ? 'stroke-primary':'']),
                      "stroke-width": "1.5",
                      "stroke-miterlimit": "10",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    }, null, 2)
                  ]))
                ], 2),
                _createElementVNode("p", {
                  class: _normalizeClass(["text-xs sm:text-sm", orderProductBy.value == 'price' ? 'text-primary':''])
                }, "Preço", 2)
              ]),
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("button", {
                  class: _normalizeClass(["border rounded-full p-5 duration-200", orderProductBy.value == 'discount' ? 'border-transparent outline outline-2 outline-primary':'outline-none']),
                  onClick: _cache[6] || (_cache[6] = ($event: any) => {orderProductBy.value = 'discount'; isOrderByModalOpen.value = false})
                }, [
                  (_openBlock(), _createElementBlock("svg", _hoisted_34, [
                    _createElementVNode("path", {
                      d: "M4.42233 15.5264L8.95233 20.0564C10.8123 21.9164 13.8323 21.9164 15.7023 20.0564L20.0923 15.6664C21.9523 13.8064 21.9523 10.7864 20.0923 8.91637L15.5523 4.39637C14.6023 3.44637 13.2923 2.93637 11.9523 3.00637L6.95233 3.24637C4.95233 3.33637 3.36233 4.92637 3.26233 6.91637L3.02233 11.9164C2.96233 13.2664 3.47233 14.5764 4.42233 15.5264Z",
                      stroke: "#292f31",
                      class: _normalizeClass(["", orderProductBy.value == 'discount' ? 'stroke-primary':'']),
                      "stroke-width": "1.5",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    }, null, 2),
                    _createElementVNode("path", {
                      d: "M9.75244 12.2263C11.1332 12.2263 12.2524 11.107 12.2524 9.72632C12.2524 8.34561 11.1332 7.22632 9.75244 7.22632C8.37173 7.22632 7.25244 8.34561 7.25244 9.72632C7.25244 11.107 8.37173 12.2263 9.75244 12.2263Z",
                      stroke: "#292f31",
                      class: _normalizeClass(["", orderProductBy.value == 'discount' ? 'stroke-primary':'']),
                      "stroke-width": "1.5",
                      "stroke-linecap": "round"
                    }, null, 2),
                    _createElementVNode("path", {
                      d: "M13.2524 17.2263L17.2524 13.2263",
                      stroke: "#292f31",
                      class: _normalizeClass(["", orderProductBy.value == 'discount' ? 'stroke-primary':'']),
                      "stroke-width": "1.5",
                      "stroke-miterlimit": "10",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    }, null, 2)
                  ]))
                ], 2),
                _createElementVNode("p", {
                  class: _normalizeClass(["text-xs sm:text-sm", orderProductBy.value == 'discount' ? 'text-primary':''])
                }, "Maior desconto", 2)
              ])
            ])
          ]),
          _: 1
        }, 8, ["isOpen", "toggleModal"]),
        _createVNode(ProductModal, {
          isOpen: isProductModalOpen.value,
          setSelectedProductVariations: (value) => selectedProduct.value.variations = value,
          toggleModal: (value) => isProductModalOpen.value = value,
          selectedProduct: selectedProduct.value,
          setSelectedProduct: (product) => selectedProduct.value = product
        }, null, 8, ["isOpen", "setSelectedProductVariations", "toggleModal", "selectedProduct", "setSelectedProduct"])
      ]))
    : _createCommentVNode("", true)
}
}

})